// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a396df83","239":"c86d112d","455":"fb38f8ab"}[chunkId] + ".chunk.js";
};